import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/config';
import { UploadFileInfo } from '../models/uploadFileInfo.model';
import { ResponsePackage } from '../models/util.model';

@Injectable({
  providedIn: 'root'
})
export class UploadFileInfoService {

  private pathApi = this.config.setting['pathApi'] + "uploadFileInfo/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  getByType(type: any): Observable<any> {
    return this.http.post<ResponsePackage<UploadFileInfo[]>>(`${this.pathApi}getByType`, type);
  }


}
